module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAHJCAIAAAAtkg/3AAAABnRSTlMAOQB9ACpFBe+zAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAYUlEQVR42u3NMRWAMBAE0UlwAwrAGxSxgwMExEHsEIpAQALFbDX3rvhhXkcgpwLEXkCotfIs8tl7LNsUe92fVsBwnHurnErspaOjo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo/NT5wJcyjocJBFIfgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/stripes.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/stripes.png
// module chunks = styles